<template>
  <div class="home">
    <Section light>
      <v-col class="col-lg-10 offset-lg-1">
        <v-container>
          <v-row justify="center">
            <v-col cols="12">
              <h1>Thanks to our sponsors!</h1>
            </v-col>

            <v-col
              v-for="sponsor in sponsors"
              :key="sponsor.name"
              cols="12" sm="8" md="6"
              class="d-flex justify-center"
            >
              <v-card flat color="white" rounded="lg" class="pa-6">
                <a
                  :href="sponsor.url"
                  target="_blank"
                  class="d-flex align-center justify-center"
                  style="width:100%; height:100%;"
                >
                  <v-img
                    :src="sponsor.image"
                    contain
                    width="100%"
                    height="100%"
                  />
                </a>
              </v-card>
            </v-col>

            <div class="col-sm-12" style="margin-top: 25px; margin-bottom: 15px">
              <h1>And to our crowdfunding backers!</h1>
            </div>
            <h3 class="mb-6">
              <span
                class="px-3"
                style="white-space: nowrap; display: inline-block"
                v-for="name of indie"
                :key="name"
                >{{ name }}</span
              >
            </h3>
          </v-row>
        </v-container>
      </v-col>
    </Section>
  </div>
</template>

<script>
import Section from '@/components/Section.vue';
import digikeyImg from '@/assets/sponsors/digikey.png';
import thorlabsImg from '@/assets/sponsors/thorlabs.png';
import intellisurveyImg from '@/assets/sponsors/intellisurvey.png';
import altairImg from '@/assets/sponsors/altair.png';
import ideaImg from '@/assets/sponsors/ideaengineering.png';
import protocaseImg from '@/assets/sponsors/protocase.png';
import kenestoImg from '@/assets/sponsors/kenesto.png';
import cubemarsImg from '@/assets/sponsors/cubemars.png';
import dfrobotImg from '@/assets/sponsors/dfrobot.png';
import odriveImg from '@/assets/sponsors/odrive.png';
import pcbwayImg from '@/assets/sponsors/pcbway.png';
import redbullImg from '@/assets/sponsors/redbull.png';
import ucsdjsoeImg from '@/assets/sponsors/ucsdjsoe.png';
import ucsdmakerspaceImg from '@/assets/sponsors/ucsdmakerspace.png';
import openmvImg from '@/assets/sponsors/openmv.png';

export default {
  name: 'Footer',
  components: {
    Section,
  },
  data() {
    return {
      indie: [
        'Alexander Haggart',
        'Vaishali Patil',
        'Cyrus Cowley',
        'Alex Smith',
        'Luke Piszkin',
        'Brandon Ho',
        'Andrea Pabst',
        'Robin Wang',
        'Lucas Wang',
        'Joseph Payne',
        'Allison Kubo',
      ],
      sponsors: [
        {
          name: 'Thorlabs',
          url: 'https://www.thorlabs.com/',
          image: thorlabsImg,
        },
        {
          name: 'Digikey',
          url: 'https://www.digikey.com/',
          image: digikeyImg,
        },
        {
          name: 'UCSD Makerspace',
          url: 'https://makerspace.ucsd.edu',
          image: ucsdmakerspaceImg,
        },
        {
          name: 'UCSD Jacobs School of Engineering',
          url: 'https://jacobsschool.ucsd.edu',
          image: ucsdjsoeImg,
        },
        {
          name: 'Protocase',
          url: 'https://www.protocase.com/',
          image: protocaseImg,
        },
        {
          name: 'IDEA Engineering',
          url: 'http://jacobsschool.ucsd.edu/idea/',
          image: ideaImg,
        },
        {
          name: 'ODrive',
          url: 'https://odriverobotics.com/',
          image: odriveImg,
        },
        {
          name: 'DFRobot',
          url: 'https://www.dfrobot.com/',
          image: dfrobotImg,
        },
        {
          name: 'CubeMars',
          url: 'https://www.cubemars.com/',
          image: cubemarsImg,
        },
        {
          name: 'PCBWay',
          url: 'https://www.pcbway.com/',
          image: pcbwayImg,
        },
        {
          name: 'Red Bull',
          url: 'https://www.redbull.com/us-en/',
          image: redbullImg,
        },
        {
          name: 'Kenesto',
          url: 'https://www.kenesto.com/',
          image: kenestoImg,
        },
        {
          name: 'Altair',
          url: 'https://www.altair.com/',
          image: altairImg,
        },
        {
          name: 'Intellisurvey',
          url: 'https://www.intellisurvey.com/',
          image: intellisurveyImg,
        },
        {
          name: 'Peninsula MV',
          url: 'https://openmv.io/',
          image: openmvImg,
        },
      ],
    };
  },
};
</script>

<style scoped>
h1,
h3 {
  color: white;
}
h3 {
  font-size: 28px;
  text-align: center;
}
</style>
